import styles from "./index.module.scss";

interface ActionsButtonProps {
    isProgramTeam: boolean;
    isTaskCompleted: boolean;
    isClassFull: boolean;
    isSelected: boolean;
    isLoading: boolean;
    isCancellationDisabled?: boolean;
}

const ActionsButton = ({ 
    isProgramTeam, 
    isTaskCompleted, 
    isClassFull, 
    isSelected, 
    isLoading, 
    isCancellationDisabled 
}: ActionsButtonProps) => {
    return (
        <div className={styles.actions}>
            {!isProgramTeam && !isTaskCompleted && (!isClassFull || isSelected) && (
                <div 
                    className={`${styles.actionsBtn} ${isSelected ? styles.selected : ""} ${isLoading ? styles.loading : ""} ${isCancellationDisabled ? styles.cancellationDisabled : ""}`}
                    title={isCancellationDisabled ? "Cannot cancel: This selection is required by other dependencies" : ""}
                />
            )}
        </div>
    );
};

export default ActionsButton;

